import { countyRequest } from '@/common/queries/selections/countyRequest';
import { queryOptions } from '@tanstack/react-query';

export const UseGetAllCounty = (name: string) =>
  queryOptions({
    queryKey: ['countyList', name],
    staleTime: 1000 * 60 * 10,
    gcTime: 1000 * 60 * 30,
    queryFn: () => countyRequest({ countyName: name }),
    select: (data) => {
      return data?.results.map((item) => ({
        label: item.name,
        value: item.id,
      }));
    },
  });
